module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_arrow_top_black-77c3f1e503c85c5d7edc3643b9e6b3e3.svg";